import React, { useState, useEffect } from 'react'
import Swal from 'sweetalert2'
import $ from 'jquery'
import ICE_curriculum_page from './ICE_curriculum_page'
import ICE_Pricing_card from './ICE_Pricing_card'
import ICE_Review_Program_Page from './ICE_Review_Program_Page'
import ICE_FAQ_page from './ICE_FAQ_page'
import Certificates from '../Certificates'
import Counsellor from '../Counsellor'
import All_Program_Mentor from '../All_Program_Mentor'
import { Helmet } from 'react-helmet-async'
import { SlUser } from 'react-icons/sl'
import { HiOutlinePhone } from 'react-icons/hi'
import { MdOutlineMailOutline } from 'react-icons/md'
import { HiOutlineBuildingLibrary } from "react-icons/hi2";
import { LiaSwatchbookSolid } from "react-icons/lia";
import ICE from "../image/IC_Engine.jpg"
import DemoClass from '../DemoClass'

function ICE_page() {
  const canonicalUrl = 'https://www.internselite.net/IC-Engine'

  useEffect(() => {
    document.title =
      'IC Engine | Traineeship Program | InternsElite'
  }, [])

  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    mobileNo: '',
    collegeName: '',
    programName: '',
  })

  const [nameError, setNameError] = useState(' ')
  const [emailError, setEmailError] = useState('')
  const [phoneError, setPhoneError] = useState('')
  const [collegeError, setCollegeError] = useState('')
  const [programError, setProgramError] = useState('')

  const handleInputChange = (event) => {
    const { name, value } = event.target

    if (name === 'fullName') {
      if (!value || !/^[A-Za-z\s]+$/.test(value)) {
        setNameError(`Invalid name format.`)
      } else {
        setNameError('')
      }
    }

    if (name === 'email') {
      if (!value || !/\S+@\S+\.\S+/.test(value)) {
        setEmailError('Invalid email format')
      } else {
        setEmailError('')
      }
    }

    if (name === 'mobileNo') {
      if (!value || !/^\d{10}$/.test(value)) {
        setPhoneError('Length Should be 10 Digit')
      } else {
        setPhoneError('')
      }
    }
    if (name === 'collegeName') {
      if (!value || !/^[A-Za-z\s]+$/.test(value)) {
        setCollegeError(`Invalid College Name format.`)
      } else {
        setCollegeError('')
      }
    }
    if (name === 'programName') {
      if (!value || !/^[A-Za-z\s]+$/.test(value)) {
        setProgramError(`Invalid Program Name format.`)
      } else {
        setProgramError('')
      }
    }
    setFormData({
      ...formData,
      [name]: value,
    })
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    $.ajax({
      url: 'https://forms.internselite.net/traineeship/T2',
      type: 'POST',
      data: {
        fullName: $('[name="fullName"]').val(),
        mobileNo: $('[name="mobileNo"]').val(),
        email: $('[name="email"]').val(),
        collegeName: $('[name="collegeName"]').val(),
        programName: $('[name="programName"]').val(),
      },
      success: function (response) {
        Swal.fire({ 
          title: 'Form Submitted!',
          text:
            'Thank you for your interest in the Traineeship Program! Our counsellor will contact you within 24 hours with the next steps.',
          icon: 'success',
        })
        $('[name="fullName"]').val('')
        $('[name="mobileNo"]').val('')
        $('[name="email"]').val('')
        $('[name="collegeName"]').val('')
        $('[name="programName"]').val('')
      },
      error: function (error) {
        console.error('Error:', error)
      },
    })
  }

  return (
    <>
    <style>{`
        .ICE_program_details_image{
          background-image:url(${ICE});
          background-repeat: no-repeat;
          background-size: cover;
          z-index:-1 !important;
        }
        .ICE_program_details_image .background_color{
          background-image: linear-gradient(rgb(7, 7, 7,0.5), rgba(7,7,7,0.7));
          width:100%;
        }
      `}</style>
    <div>
      <Helmet>
        <title>
          IC Engine Course and internship – InternsElite
        </title>
        <meta
          name="description"
          content="Explore engine dynamics with InternsElite’s IC Engine course. Study internal combustion engines, thermodynamics, and automotive fundamentals. "
        />
        <meta
          name="keywords"
          content="IC engine training, internship program, IC engine internship and training, IC engine course with Internship, best IC engine course for students."
        />
        <meta
          property="og:title"
          content="IC Engine Course and internship – InternsElite"
        />
        <meta
          property="og:description"
          content="Explore engine dynamics with InternsElite’s IC Engine course. Study internal combustion engines, thermodynamics, and automotive fundamentals. "
        />
        <meta
          property="og:url"
          content="https://internselite.net/IC-Engine"
        />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@internselite" />
        <meta
          name="twitter:title"
          content="IC Engine Course and internship – InternsElite"
        />
        <meta
          name="twitter:description"
          content="Explore engine dynamics with InternsElite’s IC Engine course. Study internal combustion engines, thermodynamics, and automotive fundamentals. "
        />
        <meta
          name="twitter:image"
          content="https://internselite.net/static/media/logo.c1eb8ff81ef75599f376.png"
        />
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>

      {/* -----------------Mobile View----------------------- */}
      <div className="ICE_program_details_image d-sm-block d-md-none  py-5">
        <div className="container-fluid background_color">
          <div className="row mt-4">
            <div className="col-md-12">
              <div className="Details_Main_text">
                <h1 className="display-5 pt-5 text-white">
                 IC Engine Traineeship Program
                </h1>
                <h4 className="text-white pt-2">
                  Start Learning IC Engine by Top
                  Industry Experts...
                </h4>
                <a href="#ICE">
                  <button className="text-white shadow-sm mt-4 mb-5 fs-5 px-4 pt-1 pb-2 Pr_details_button">
                    Read More...
                  </button>
                </a>
              </div>
            </div>
            <div className='col-md-12'>
                <div className='Program_details_form  px-3'>
                    <div className='py-4'>
                    <p className='text-center fs-3'>Apply Now</p>
                    <form onSubmit={handleSubmit}>
                          <div class="mt-2">
                            <label for="fullName" class="pb-2 contact_form"><SlUser size="18px"/>{' '}Full Name</label>
                            <input
                              className='form-control'
                              type="text"
                              id="fullName"
                              name="fullName"
                              placeholder="Your answer"
                              value={formData.fullName}
                              onChange={handleInputChange}
                              required
                            />
                            {nameError && <div className="error text-danger">{nameError}</div>}
                          </div>
                          <div class="mt-3">
                            <label for="email" class="pb-2 contact_form"><MdOutlineMailOutline size="18px"/>{' '}Email Address</label>
                            <input
                              className='form-control'
                              type="email"
                              id="email"
                              name="email"
                              placeholder="Your answer"
                              value={formData.email}
                              onChange={handleInputChange}
                              required
                            />
                            {emailError && <div className="error text-danger">{emailError}</div>}
                          </div>
                          <div class="mt-3">
                            <label for="mobileNo" class="pb-2 contact_form"><HiOutlinePhone size="18px"/>{' '}Phone Number</label>
                            <input
                              className='form-control'
                              type="tel"
                              id="mobileNo"
                              name="mobileNo"
                              placeholder="+91 xxxxxxxxxx"
                              value={formData.mobileNo}
                              onChange={handleInputChange}
                              required
                            />
                            {phoneError && <div className="error text-danger">{phoneError}</div>}
                          </div>
                          <div class="mt-3">
                            <label for="collegeName" class="pb-2 contact_form"><HiOutlineBuildingLibrary size="18px"/>{' '}College Name</label>
                            <input
                              className='form-control'
                              type="text"
                              id="collegeName"
                              name="collegeName"
                              placeholder="Your answer"
                              value={formData.collegeName}
                              onChange={handleInputChange}
                              required
                            />
                            {collegeError && <div className="error text-danger">{collegeError}</div>}
                          </div>
                          <div class="mt-3">
                            <label for="programName" class="pb-2 contact_form"><LiaSwatchbookSolid size="18px"/>{' '}Program</label>
                            <input
                              type="text"
                              readonly class="form-control form-control-plaintext px-2"
                              id="programName"
                              placeholder="Your answer"
                              value="IC Engine"
                              required />
                            {programError && <div className="error text-danger">{programError}</div>}
                          </div>
                          
                        <div className='row mt-2 pt-4'>
                          <div className='d-flex justify-content-center'>
                            <button className="text-white shadow-sm fs-5 px-5 pt-1 pb-2 Pr_details_button">Submit</button>
                          </div>
                        </div>
                    </form>
                    </div>  
                    </div>
              </div>
          </div>
        </div>
      </div>

      
      {/* ----------------Desktop view----------------- */}
      <div className="ICE_program_details_image d-none d-md-block  mt-5">
        <div className="container-fluid background_color py-5">
          <div className="row mt-5">
            <div className="col-md-7">
              <div className="px-5 pt-5 Details_Main_text">
                <h1 className="display-5 mt-5 pt-5 text-white">
               IC Engine Traineeship Program
                </h1>
                <h4 className="text-white pt-3">
                  Start Learning IC Engine by Top
                  Industry Experts...
                </h4>
                <a href="#ICE">
                  <button className="text-white shadow-sm my-3 fs-5 px-4 pt-1 pb-2 Pr_details_button">
                    Read More...
                  </button>
                </a>
              </div>
            </div>
            <div className="col-md-5 px-3 pt-2">
              <div className="container">
                <div className="">
                  <div className="">
                  <div className='Program_details_form px-5'>
                    <div className='py-4'>
                    <p className='text-center fs-3'>Apply Now</p>
                    <form onSubmit={handleSubmit}>
                          <div class="mt-2">
                            <label for="fullName" class="pb-2 contact_form"><SlUser size="18px"/>{' '}Full Name</label>
                            <input
                              className='form-control'
                              type="text"
                              id="fullName"
                              name="fullName"
                              placeholder="Your answer"
                              value={formData.fullName}
                              onChange={handleInputChange}
                              required
                            />
                            {nameError && <div className="error text-danger">{nameError}</div>}
                          </div>
                          <div class="mt-3">
                            <label for="email" class="pb-2 contact_form"><MdOutlineMailOutline size="18px"/>{' '}Email Address</label>
                            <input
                              className='form-control'
                              type="email"
                              id="email"
                              name="email"
                              placeholder="Your answer"
                              value={formData.email}
                              onChange={handleInputChange}
                              required
                            />
                            {emailError && <div className="error text-danger">{emailError}</div>}
                          </div>
                          <div class="mt-3">
                            <label for="mobileNo" class="pb-2 contact_form"><HiOutlinePhone size="18px"/>{' '}Phone Number</label>
                            <input
                              className='form-control'
                              type="tel"
                              id="mobileNo"
                              name="mobileNo"
                              placeholder="+91 xxxxxxxxxx"
                              value={formData.mobileNo}
                              onChange={handleInputChange}
                              required
                            />
                            {phoneError && <div className="error text-danger">{phoneError}</div>}
                          </div>
                          <div class="mt-3">
                            <label for="collegeName" class="pb-2 contact_form"><HiOutlineBuildingLibrary size="18px"/>{' '}College Name</label>
                            <input
                              className='form-control'
                              type="text"
                              id="collegeName"
                              name="collegeName"
                              placeholder="Your answer"
                              value={formData.collegeName}
                              onChange={handleInputChange}
                              required
                            />
                            {collegeError && <div className="error text-danger">{collegeError}</div>}
                          </div>
                          <div class="mt-3">
                            <label for="programName" class=" pb-2  contact_form"><LiaSwatchbookSolid size="18px"/>{' '}Program</label>
                            <input
                              type="text"
                              readonly class="form-control form-control-plaintext px-2"
                              id="programName"
                              placeholder="Your answer"
                              value="IC Engine"
                              required />
                            {programError && <div className="error text-danger">{programError}</div>}
                          </div>
                          
                        <div className='row mt-2 pt-4'>
                          <div className='d-flex justify-content-center'>
                            <button className="text-white shadow-sm fs-5 px-5 pt-1 pb-2 Pr_details_button">Submit</button>
                          </div>
                        </div>
                    </form>
                    </div>
                </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="ICE" className="py-5"><ICE_program_details /></div>
      <div className="Curriculum_Containte_box  py-5">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-2"></div>
            <div className="col-md-8">
              <div className="text-center Curriculum_Main_text">
                <h2 className="display-6 pb-1">Program Curriculum</h2>
                <p className='px-2'>
                  A comprehensive and dynamic syllabus designed to empower your
                  skills and propel your success in every aspect of your
                  professional and personal development.
                </p>
              </div>
            </div>
            <div className="col-md-2"></div>
          </div>
          <div className="row">
            <div className="col-md-1"></div>
            <div className="col-md-10">
              <div className="mt-3">
                <ICE_curriculum_page />
              </div>
              <div className="col-md-1"></div>
            </div>
          </div>
        </div>
      </div>
      <Certificates />
      <ICE_Pricing_card />
      <DemoClass/>
      {/* <All_Program_Mentor /> */}
      <ICE_Review_Program_Page />
      <ICE_FAQ_page />
      <Counsellor />
    </div>
    </>
  )
}

function ICE_program_details(){
  return(
    <>
     <div>
      {/* -------------------Mobile View------------------- */}
      <div className="d-sm-block d-md-none">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="text-center Program_details_1stcomp_text_mobile">
                <h2 className="display-6">
                  Power Your Future with IC Engines
                </h2>
                <p className="py-2">
                  Learn IC engine technology in simple steps. 
                  Study engine parts, fuel systems, and performance basics. 
                  Work on real projects. Build hands-on skills for careers 
                  in automotive, mechanical, and power industries.
                </p>
              </div>
              <div className="mt-4 text-center Program_details_1stcomp_text_mobile">
                <h2 className="display-6 text-center">Overview</h2>
                <p className="py-2">
                  Our IC Engine program teaches engine technology in simple steps. 
                  Learn engine parts, fuel systems, and performance basics. 
                  Work on real projects to gain hands-on experience. Understand how 
                  engines operate and how to fix common problems. Explore ways to 
                  improve engine efficiency. This practical training prepares you for 
                  careers in automotive, mechanical, and power industries. Each lesson 
                  is clear and easy to follow. With step-by-step practice and project work, 
                  you will build the skills, confidence, and knowledge needed to succeed as a 
                  professional in IC Engine technology.
                </p>
              </div>
            </div>
            <div className="col-md-12">
              <div>
                <div className="Details_container shadow-lg px-1 py-4">
                  <h3 className="Details_text text-center  pb-2 border-bottom">
                    IC Engine
                  </h3>
                  <div className="Details_text">
                    <ul className="pt-2">
                       <li>Learn from live expert sessions with industry professionals</li>
                    <li className="py-3">Project support and guidance</li>
                    <li>Access exclusive program material </li>
                    <li className="py-3">25+ learning hours</li>
                    <li>
                      Certification to boost your career profile and achieve growth & success                     
                    </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ---------------------Desktop view----------------- */}
      <div className="d-none d-md-block">
        <div className="container">
          <div className="row">
            <div className="col-md-8 detail_1stcomp_img">
              <div className="pt-3 Program_details_1stcomp_text">
                <h2 className="fs-2">
                  {' '}
                  Power Your Future with IC Engines
                </h2>
                <p className="py-2">
                  Learn IC engine technology in simple steps. 
                  Study engine parts, fuel systems, and performance basics. 
                  Work on real projects. Build hands-on skills for careers in automotive, 
                  mechanical, and power industries.
                </p>
              </div>
              <div className="mt-3 Program_details_1stcomp_text">
                <h2 className="display-6">Overview</h2>
                <p className="py-2">
                  Our IC Engine program teaches engine technology in simple steps. 
                  Learn engine parts, fuel systems, and performance basics. 
                  Work on real projects to gain hands-on experience. Understand 
                  how engines operate and how to fix common problems. Explore 
                  ways to improve engine efficiency. This practical training prepares 
                  you for careers in automotive, mechanical, and power industries. 
                  Each lesson is clear and easy to follow. With step-by-step practice 
                  and project work, you will build the skills, confidence, and knowledge 
                  needed to succeed as a professional in IC Engine technology.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="Details_container shadow-lg px-3 py-4">
                <h3 className="Details_text text-center  pb-4 pt-3 border-bottom">
                IC Engine
                </h3>
                <div className="Details_text ">
                  <ul className="pt-3">
                    <li>Learn from live expert sessions with industry professionals</li>
                    <li className="py-3">Project support and guidance</li>
                    <li>Access exclusive program material </li>
                    <li className="py-3">25+ learning hours</li>
                    <li>
                      Certification to boost your career profile and achieve growth & success                     
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  )
}
export default ICE_page







